import { Box, CircularProgress } from "@mui/material";
import themestyle from "../theme";

type CenteredLoaderProps = {
  minHeight?: number | string;
  size?: number;
};

const CenteredLoader = ({
  minHeight = 200,
  size = 28,
}: CenteredLoaderProps) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight,
      width: "100%",
    }}
  >
    <CircularProgress
      size={size}
      thickness={2}
      sx={{ color: themestyle.colors.activeGreen }}
    />
  </Box>
);
export default CenteredLoader;
